import { render } from "./AdminEditPersonForm.vue?vue&type=template&id=5252137b&scoped=true"
import script from "./AdminEditPersonForm.vue?vue&type=script&lang=js"
export * from "./AdminEditPersonForm.vue?vue&type=script&lang=js"

import "./AdminEditPersonForm.vue?vue&type=style&index=0&id=5252137b&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5252137b"]])

export default __exports__